import React from 'react'
import { Link, withRouter } from "react-router-dom";
import './LandingPage.scss'
import RandomImages from '../RandomImages/RandomImages'
import SearchBar from '../SearchBar/SearchBar'

const arrowStyle = {
    background: 'url(/wp-content/plugins/react-plugin/app/src/assets/images/icons/long-arrow-alt-right.svg) no-repeat 100% center'
};

function LandingPage(props) {
    const searchType = {
        commodity: 'commodity',
        county: 'county'
    }

    return (
        <div className="landing-page-container">
            <div className="inner-container">
                <div className="georgia-map-container">
                    <img src="/wp-content/plugins/react-plugin/app/src/assets/images/LandingPage/map-outlines.png" alt="State of Georgia Map" />
                </div>
                <div className="overview-container">
                    <div className="more-impact">
                        <h1 className="title">Statewide Economic Impact</h1>
                        <Link className="btn overview-btn" to={{
                            pathname: '/overview',
                            index: 0
                        }}>Economic Overview for Georgia <span className="arrow-icon" style={arrowStyle}></span></Link>
                        <h3 className="subtitle">Use this tool to find the volume and impact of imports and exports in Georgia <u>by county</u> and <u>commodity.</u></h3>
                    </div>
                    <div className="search-container">
                        <div className="search-by-county-commodity">
                            <SearchBar
                                searchType={searchType.county} />
                            <Link to={{
                                pathname: '/overview',
                                index: 1
                            }}>
                                See all Counties <span className="arrow-icon" style={arrowStyle}></span>
                            </Link>
                        </div>
                        <span className="seperator">Or</span>
                        <div className="search-by-county-commodity">
                            <SearchBar
                                searchType={searchType.commodity} />
                            <Link to={{
                                pathname: '/overview',
                                index: 2
                            }}>
                                See all Commodities <span className="arrow-icon" style={arrowStyle}></span>
                            </Link>
                        </div>
                    </div>
                    <div className="random-images">
                        <RandomImages />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(LandingPage);

